import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import {
  chargeAllInvoices,
  stageInvoices,
  resendDelinquentEmails
} from '../requests/payment.request';
import { ChargeAllOptions, ResendDelinquentEmailsRequest } from '../types/payment.types';

export const useChargeAllMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (options: ChargeAllOptions) => await chargeAllInvoices(options),
    onSuccess: () => {
      queryClient.invalidateQueries(['charge-attempts']);
      queryClient.invalidateQueries(['charge-attempt-statistics']);
      queryClient.invalidateQueries(['failed-invoices']);
    },
    onError: () => {
      toast.error('Charge all failed');
    }
  });
};

export const useStageInvoicesMutation = () => {
  return useMutation({
    mutationFn: stageInvoices,
    onSuccess: () => {
      toast.success('Stage invoices completed');
    },
    onError: () => {
      toast.error('Stage invoices failed');
    }
  });
};

export const useResendDelinquentEmailsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (request: ResendDelinquentEmailsRequest) =>
      await resendDelinquentEmails(request),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['charge-attempts']);
      if (data.failed === 0) {
        toast.success(`Successfully sent ${data.successfullySent} delinquent email(s)`);
      } else if (data.successfullySent === 0) {
        toast.error(`Failed to send all ${data.failed} email(s)`);
      } else {
        toast.success(`Sent ${data.successfullySent} email(s), ${data.failed} failed`);
      }
    },
    onError: () => {
      toast.error('Failed to resend delinquent emails');
    }
  });
};
